import React from 'react';
import StadiumShell from '../../layouts/StadiumShell';

/** Shown while Lockbox chunk loads — lightweight, no network I/O. */
export default function AppBootFallback() {
  return (
    <StadiumShell className="flex flex-col items-center justify-center gap-4 p-8">
      <div className="w-12 h-12 rounded-2xl bg-emerald-500/20 border border-emerald-500/40 flex items-center justify-center text-emerald-400 font-black italic text-sm animate-pulse">
        LI
      </div>
      <p className="text-[10px] font-black uppercase tracking-[0.25em] text-gray-500">
        Loading The Lockbox…
      </p>
    </StadiumShell>
  );
}
